import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled from '@emotion/styled';

import ActionButton from '../ActionButton/ActionButton';
import { TranslationKeys } from '../../../i18n/locales/defaultResources';
import { useI18n } from '../../../hooks/useI18n';

interface AlertProps {
  title?: string;
  messageType: string;
  isOpen: boolean;
  onClose: () => void;
  confirmText?: string;
}

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 9999;
`;

const Modal = styled.div`
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 24px;
  max-width: 400px;
  width: 100%;
  height: auto;
`;

const Message = styled.p`
  margin: 0 0 16px;
  font-size: 1rem;
  line-height: 1.5;
`;

const Alert: React.FC<AlertProps> = ({ messageType, isOpen, onClose }) => {
  const { t } = useI18n();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <Overlay>
      <Modal>
        <Message>
          {messageType === 'wrongFileType'
            ? t(TranslationKeys.file_upload_component_wrong_type_message)
            : t(TranslationKeys.file_upload_component_wrong_size_message)}
        </Message>
        <div style={{ textAlign: 'right' }}>
          <ActionButton
            variant="accept-blue"
            buttonText={t(TranslationKeys.alert_confirm_button_text)}
            onClickAction={onClose}
          />{' '}
        </div>
      </Modal>
    </Overlay>,
    document.body
  );
};

export default Alert;
